import AFRAME from 'aframe'
import Gyro from 'src/helpers/Gyro'
import store from 'src/store'

AFRAME.registerComponent('gyro-position', {
  schema: {
    // multiplierT: {
    //   type: 'number',
    //   default: 1.0
    // },
    delay: {
      type: 'number',
      default: 1.0,
    },
    active: {
      type: 'boolean',
      default: true,
    },
    multiplier: {
      type: 'number',
      default: 0.005,
    },
    limit: {
      type: 'vec2',
      default: {
        x: 90,
        y: 90,
      },
    },
  },
  init: function() {
    // PROPERTIES
    this.offset = { x: 0, y: 0, z: 0 }
    this.target = { x: 0, y: 0 }
    this.lastTime = 0

    // METHODS
    this._checkLimit = AFRAME.utils.bind(this._checkLimit, this)
    this._onMouseMove = AFRAME.utils.bind(this._onMouseMove, this)
    this.touchMove = AFRAME.utils.bind(this.touchMove, this)
    this._onTouchStart = AFRAME.utils.bind(this._onTouchStart, this)
    this._onTouchEnd = AFRAME.utils.bind(this._onTouchEnd, this)
    this._onTouchMove = AFRAME.utils.bind(this._onTouchMove, this)
    this._onGyroUpdate = AFRAME.utils.bind(this._onGyroUpdate, this)

    // // LISTEN
    // //window.addEventListener('mousemove', this._onMouseMove)
    // if (store.state.browser.isMobile) {
    //   Gyro.on(Gyro.Events.UPDATE, this._onGyroUpdate)
    //   // window.addEventListener('touchstart', this._onTouchStart)
    //   // window.addEventListener('touchmove', this._onTouchMove)
    //   // window.addEventListener('touchend', this._onTouchEnd)
    // } else {
    //   window.addEventListener('mousemove', this._onMouseMove)
    // }

    // ANIM
    Object.defineProperty(this, 'limitX', {
      get: function() {
        return this.data.limit.x
      },
      set: function(val) {
        this.data.limit.x = val
      },
    })
    Object.defineProperty(this, 'limitY', {
      get: function() {
        return this.data.limit.y
      },
      set: function(val) {
        this.data.limit.y = val
      },
    })

    Object.defineProperty(this, 'multiplier', {
      get: function() {
        return this.data.multiplier
      },
      set: function(val) {
        this.data.multiplier = val
      },
    })
  },
  update: function() {
    this._checkLimit()
  },
  remove: function() {
    Gyro.off(Gyro.Events.UPDATE, this._onGyroUpdate)
    window.removeEventListener('mousemove', this._onMouseMove)
    // window.removeEventListener('touchstart', this._onTouchStart)
    // window.removeEventListener('touchmove', this._onTouchMove)
    // window.removeEventListener('touchend', this._onTouchEnd)
  },
  tick: function() {

    if (!this.data.active) return
    //console.log(this.offset.x)
    this.offset.x = this.offset.x + (this.target.x - this.offset.x) * this.data.delay
    this.offset.y = this.offset.y + (this.target.y - this.offset.y) * this.data.delay
    // AFRAME.utils.entity.setComponentProperty(this.el, 'position', {
    //   x: -this.offset.x,
    //   y: -this.offset.y,
    // })

    this.el.object3D.position.x = -this.offset.x
    this.el.object3D.position.y = -this.offset.y

    // console.log(this.el, this.el.components.position.data.x)
  },
  enableListener: function(){
    if (store.state.browser.isMobile) {
      Gyro.on(Gyro.Events.UPDATE, this._onGyroUpdate)
    } else {
      window.addEventListener('mousemove', this._onMouseMove)
    }
  },
  disableListener: function(){
    Gyro.off(Gyro.Events.UPDATE, this._onGyroUpdate)
    window.removeEventListener('mousemove', this._onMouseMove)
    this._reset()
  },
  _reset: function(){
    this.target.x = 0
    this.target.y = 0
  },
  tock: function() {},
  play: function() {},
  pause: function() {},
  updateSchema: function() {},
  _onMouseMove: function(evt) {
    this.target.x = -2 * (evt.pageX / window.innerWidth - 0.5) * this.data.limit.x
    this.target.y = -2 * (evt.pageY / window.innerHeight - 0.5) * this.data.limit.y
    this._checkLimit()

  },
  touchMove: function(diff) {
    this.target.x += diff.x * 3.0
    this.target.y += diff.y * 2.0
    this._checkLimit()

  },
  // _onTouchStart: function(evt) {
  //   // this.target.x = -2 * (evt.pageX / window.innerWidth - 0.5) * this.data.limit.x
  //   // this.target.y = -2 * (evt.pageY / window.innerHeight - 0.5) * this.data.limit.y
  //   // this._checkLimit()
  //   this.lastTime = Date.now() / 1000
  //   console.log('start', evt)
  // },
  // _onTouchMove: function(e) {
  //   let evt = e.touches[0]
  //   this.target.x = 2 * (evt.pageX / window.innerWidth - 0.5) * this.data.limit.x
  //   this.target.y = 2 * (evt.pageY / window.innerHeight - 0.5) * this.data.limit.y
  //   this._checkLimit()
  //   this.lastTime = Date.now() / 1000
  //   console.log('move', evt, this.target.x, this.target.y)
  // },
  // _onTouchEnd: function(evt) {
  //   var now = Date.now() / 1000
  //   var delta = now - this.lastTime
  //   this.lastTime = now
  //   // this.target.x = -2 * (evt.pageX / window.innerWidth - 0.5) * this.data.limit.x
  //   // this.target.y = -2 * (evt.pageY / window.innerHeight - 0.5) * this.data.limit.y
  //   // this._checkLimit()
  //   console.log('end', evt)
  // },
  _onGyroUpdate: function(evt) {
    this.target.x += evt.beta * this.data.multiplier
    this.target.y -= evt.alpha * this.data.multiplier
    this._checkLimit()
  },
  _checkLimit: function() {
    let limit = this.data.limit
    if (this.target.x > limit.x) this.target.x = limit.x
    if (this.target.x < -limit.x) this.target.x = -limit.x
    if (this.target.y > limit.y) this.target.y = limit.y
    if (this.target.y < -limit.y) this.target.y = -limit.y
  },
})
